import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../../../stores/types/types';
import { 
	loadMasks,
 } from '../../../../stores/actions/masks';
import { ProfileMask, NewProfileMask } from '../../../../stores/types/masks';
import { UpsertMaskEntity, AttachMask } from '../../../../connection/masks';
import styled from 'styled-components';
import ProfileCard from './profile-card';
import { setProfileInfo, updateProfile } from '../../../../stores/actions/session';
import useEditProfileMask from '../../../../hooks/use-edit-profile-mask';
import useProfile from '../../../../hooks/use-profile';

const baseMask: NewProfileMask = {
	first_name: 'Rick',
	last_name: 'Astley',
	title: 'Never gonna give you up',
	location: 'Never gonna let you down',
	avatar: '',
	bg_image: '',
	channel: 0,
};

const CardContainer = styled.div`
	display: flex;
	height: 100%;
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	gap: 8px;
`;

const Button = styled.button`
	margin: 8px;
	padding: 8px 16px;
	margin-right: 16px;
`;

const HR = styled.hr`
	margin: 8px;
`;

interface Props {
	canExpand?: boolean;
}

export default function DebugMasks({canExpand}: Props) {
	const dispatch = useDispatch();
	const channel = useSelector((state: GS) => state.SessionReducer.meeting?.channel);
	const room = useSelector((state: GS) => state.SessionReducer.meeting?.meeting);
	const gr_user = useSelector((state: GS) => state.SessionReducer.user?.gr_user ?? 0);
	const token = useSelector((state: GS) => state.SessionReducer.token);
	const {
		profileMasks,
		activeMasksEntity
	} = useSelector((state: GS) => state.MasksReducer);

	const {watchedProfile, watchedIsMasked} = useProfile({suggestedProfile: gr_user})
	const {saveProfileMask} = useEditProfileMask({watchedProfile});

	const activeMasks = activeMasksEntity?.entityValue ?? {};

	const detachMask = async (email: string) => {
		if (!room) {
			console.error('No channel');
			return;
		}

		const maskId = Number(activeMasks[email]);
		if (!maskId || Number.isNaN(maskId)) {
			console.error('No mask');
			return;
		}

		const didDetach = await AttachMask(room, maskId, email, true);
		console.log('Detached', didDetach);
		if (didDetach) {
			dispatch(loadMasks(room));
		}
	}

	const removeImagesFromProfile = () => {
		if (!token || !gr_user) return;
		const blankProperties = {avatar: '', bg_image: ''};
		const columns = {...blankProperties, gr_user};
		if (watchedIsMasked) {
			saveProfileMask(columns)
		} else {
			dispatch(setProfileInfo(blankProperties));
			dispatch(updateProfile(gr_user, columns, token));
		}
	}

	

	return (<div className="section settings">
		<div className='bl-font-l1'>Channel: {channel} | Room: {room}</div>
		<HR/>

		<Button onClick={removeImagesFromProfile} style={{marginRight: '8px'}}>
			{`Delete Images on ${watchedIsMasked ? 'Masked' : 'Base'} Profile`}
		</Button>

		<HR/>
		<div>
		<h5 className='bl-font-header' style={{color: 'white', margin: '8px 4px'}}>Active Masks</h5>
			<CardContainer style={{marginBottom: '36px'}}>
				{Object.keys(activeMasks).map((email: string) => (
					<ProfileCard 
						key={`${email}-applied-${profileMasks[activeMasks[email]]}`}
						mask={profileMasks[activeMasks[email]]}
						activeOn={email}
						canExpand={canExpand}
						detachMask={detachMask}
					/>
				))}
			</CardContainer>
			<HR/>
			<h5 className='bl-font-header' style={{color: 'white', margin: '8px 4px'}}>All Masks</h5>
			<CardContainer>
				{Object.values(profileMasks).map((mask: ProfileMask) => (
					<ProfileCard 
						key={mask.id} 
						mask={mask}
						canExpand={canExpand}
					/>
				))}
			</CardContainer>
		</div>
	</div>);
}